"use strict";

var _objectWithoutProperties = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["children", "className", "href", "onClick", "showBids", "showPerpetual"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NFTPreview = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var PricingComponent_1 = require("./PricingComponent");

var NFTDataProvider_1 = require("../context/NFTDataProvider");

var MediaThumbnailWrapper_1 = require("./MediaThumbnailWrapper");

var MediaThumbnail_1 = require("./MediaThumbnail");

var NFTPreview = function NFTPreview(_ref) {
  var children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      onClick = _ref.onClick,
      _ref$showBids = _ref.showBids,
      showBids = _ref$showBids === void 0 ? true : _ref$showBids,
      _ref$showPerpetual = _ref.showPerpetual,
      showPerpetual = _ref$showPerpetual === void 0 ? true : _ref$showPerpetual,
      wrapperProps = _objectWithoutProperties(_ref, _excluded);

  var getChildren = function getChildren() {
    if (children) {
      return children;
    }

    return jsx_runtime_1.jsxs(react_1.Fragment, {
      children: [jsx_runtime_1.jsx(MediaThumbnail_1.MediaThumbnail, {}, void 0), showBids && jsx_runtime_1.jsx(PricingComponent_1.PricingComponent, {
        showPerpetual: showPerpetual
      }, void 0)]
    }, void 0);
  };

  return jsx_runtime_1.jsx(NFTDataProvider_1.NFTDataProvider, Object.assign({}, wrapperProps, {
    children: jsx_runtime_1.jsx(MediaThumbnailWrapper_1.MediaThumbnailWrapper, Object.assign({
      className: className,
      onClick: onClick,
      href: href
    }, {
      children: getChildren()
    }), void 0)
  }), void 0);
};

exports.NFTPreview = NFTPreview;